import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";

function Returnpolicies() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <div className="row py-5 px-sm-5">
          <div className="col">
            <h1 className="text-center fw-bold">Return Policy</h1>
            <p className="mt-3">
              Return Policy ("Agreement") are entered into by and between Color Kingdon 
              ("Company") and you ("Customer").
            </p>
            <ul className="mt-4">
              <li>
                <h5 className="fw-bold">1. Return Policy</h5>
                <p>
                  <strong>7-Day Return Window:</strong> We accept returns for unused colouring 
                  books within 7 days of delivery. Products must be in original packaging, 
                  undamaged, and without any writing or colouring on the pages.
                </p>
                <p>
                  <strong>Exceptions:</strong> Custom orders, digital downloads, and clearance 
                  sale items are non-returnable. Damaged or defective products can be returned 
                  within 48 hours of delivery for immediate replacement.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">2. Refund Policy</h5>
                <p>
                  <strong>Eligible for Full Refund:</strong> Unused books returned within 7 days 
                  in original condition. Damaged/defective books reported within 48 hours.
                </p>
                <p>
                  <strong>To process your request:</strong>
                </p>
                <ul>
                  <li>Contact us at <a href="mailto:support@colorkingdon.in" className="text-success text-decoration-none">support@colorkingdon.in</a> or call +91 9251952096 within the specified time frame.</li>
                  <li>Provide clear photographs of the product and packaging for verification.</li>
                  <li>Once verified, we will issue a full refund or replacement as per your preference.</li>
                </ul>
              </li>
              <li>
                <h5 className="fw-bold">3. Process for Refund</h5>
                <p>
                  <strong>Refund Mode:</strong> Refunds will be processed through the original 
                  payment method (Razorpay/UPI/Cards). Please allow 7-10 business days for the 
                  refund to reflect in your account.
                </p>
                <p>
                  <strong>Non-Refundable Situations:</strong>
                </p>
                <ul>
                  <li>Books with writing, colouring, or damage caused by customer.</li>
                  <li>Returns after 7-day window or 48-hour defect reporting period.</li>
                  <li>Change of mind after pages have been used.</li>
                  <li>Custom personalized orders or digital downloads.</li>
                </ul>
              </li>
              <li>
                <h5 className="fw-bold">4. Replacement Policy</h5>
                <p>
                  For damaged, defective, or wrong books received, we offer free replacements. 
                  Contact us within 48 hours with photos, and we'll ship the correct item at no 
                  additional cost within 2-3 business days.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">5. Cancellation Policy</h5>
                <p>
                  Orders can be canceled before processing/shipment. Once shipped, cancellations 
                  are not allowed. To cancel, contact us immediately at <a href="mailto:support@colorkingdon.in" className="text-success text-decoration-none">support@colorkingdon.in</a> or call +91 9251952096.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">6. Return Shipping</h5>
                <p>
                  Customer is responsible for return shipping costs unless the return is due to 
                  our error (damaged/defective/wrong item). We provide prepaid return labels for 
                  eligible cases.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">7. Contact Information</h5>
                <p>
                  <strong>Color Kingdon</strong><br/>
                  📍 Sikar, Rajasthan, India<br/>
                  📧 <a href="mailto:support@colorkingdon.in" className="text-success text-decoration-none">support@colorkingdon.in</a><br/>
                  📞 <a href="tel:+919251952096" className="text-success text-decoration-none">+91 9251952096</a><br/>
                  🌐 <a href="https://colorkingdon.in" className="text-success text-decoration-none">www.colorkingdon.in</a>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default Returnpolicies;